import { useQueryHelper } from '@anytag/shared-hooks';
import { PostDetailsType } from '@anytag/shared-types';
import {
  useInstagramAnalyticsPostDetailsQuery,
  useInfluencerInstagramAnalyticsPostDetailsQuery
} from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export type TemplatePostDetailsType = Pick<PostDetailsType, 'id' | 'mainSocialAccountId'>;

export interface TemplateProps {
  className?: string;
  isAnalytics?: boolean;
}

export const Template = ({ className, isAnalytics }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPost } = usePostModalContext<TemplatePostDetailsType>();
  const { data, loading } = useInfluencerInstagramAnalyticsPostDetailsQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId || isAnalytics,
    variables: { postId: Number(selectedPost?.id), socialAccountId: Number(selectedPost?.mainSocialAccountId) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });
  const { data: analyticsData, loading: fetchingAnalyticsData } = useInstagramAnalyticsPostDetailsQuery({
    skip: !selectedPost?.id || !isAnalytics,
    variables: { postId: Number(selectedPost?.id) },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const details = data?.influencerInstagramAnalyticsPostDetails || analyticsData?.instagramAnalyticsPostDetails;

  return (
    <PostModal.DetailsTemplate
      className={className}
      loading={loading || fetchingAnalyticsData}
      data={
        details
          ? {
              socialMedia: 'INSTAGRAM',
              postUrl: details?.postUrl,
              caption: details?.content,
              postDate: details?.postDate,
              images: details?.mediaUrls || [],
              comments: details.commentList || [],
              statistics: {
                likes: details?.analysis?.likes,
                comments: details?.analysis?.comments,
                views: details?.analysis?.views,
                saves: details?.analysis?.saves,
                reach: details?.analysis?.reach,
                impressions: details?.analysis?.impressions
              },
              info: {
                avatar: details?.avatarUrl,
                followers: details?.followers,
                name: details?.instagramAccountName
              }
            }
          : undefined
      }
    />
  );
};
